import { render, staticRenderFns } from "./ComponentTermsAndConditions.vue?vue&type=template&id=a8bef90e&scoped=true&"
import script from "./ComponentTermsAndConditions.vue?vue&type=script&lang=js&"
export * from "./ComponentTermsAndConditions.vue?vue&type=script&lang=js&"
import style0 from "./ComponentTermsAndConditions.vue?vue&type=style&index=0&id=a8bef90e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8bef90e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VCard,VCardText,VSpacer,VToolbar,VToolbarTitle})
